module.exports = __webpack_public_path__ + "static/media/user.cabf63e2.svg";